export class RequestUnserviceablePostModel {
  public RequestId?: number;
  public SendTypeId?: number;
  public IsWarranty?: boolean;
  public Pn?: string;
  public Sn?: string;
  public Awb?: string;
  public FlightNo?: string;
  public CarrierEnum?: number;
  public FlightDate?: Date;
  public EstimatedDeliveryDate?: Date;
  public AirportCode?: string;
  public Tso?: number;
  public Cso?: number;
  public Dso?: number;
  public Tsr?: number;
  public Csr?: number;
  public Tsn?: number;
  public Csn?: number;
  public Dsn?: number;
  public Tsi?: number;
  public Csi?: number;
  public Dsi?: number;
  public RemoveReasonRemark?: string;
  public RemoveReasonType?: number;
  public RemoveReasonSubType?: number;
  public RemoveReasonSubCategory?: string;
  public RemoveDateFromAc?: Date;
  public Status?: number;
  public SubmittedBy?: string;
  public SubmittedDate?: Date;
  public RemoveFromAc?: string;
  public Remark?: string;
  public IsRejected?: boolean;
  public RejectedAircraftId?: number;
  public RejectedRefNo?: string;
  public PnDifferenceReasonRemark?: string;
  public Batch?: number;
  public RemovalTransactionType?: number;
  public EngineSerialNumber?: string;
}

export class RequestUnserviceablePutModel {
  public id?: number;
  public RequestId?: number;
  public SendTypeId?: number;
  public IsWarranty?: boolean;
  public Pn?: string;
  public Sn?: string;
  public Awb?: string;
  public FlightNo?: string;
  public CarrierEnum?: number;
  public FlightDate?: Date;
  public EstimatedDeliveryDate?: Date;
  public AirportCode?: string;
  public Tso?: number;
  public Cso?: number;
  public Dso?: number;
  public Tsr?: number;
  public Csr?: number;
  public Tsn?: number;
  public Csn?: number;
  public Dsn?: number;
  public Tsi?: number;
  public Csi?: number;
  public Dsi?: number;
  public RemoveReasonRemark?: string;
  public RemoveReasonType?: number;
  public RemoveReasonSubType?: number;
  public RemoveReasonSubCategory?: string;
  public RemoveDateFromAc?: Date;
  public Status?: number;
  public SubmittedBy?: string;
  public SubmittedDate?: Date;
  public updatedBy?: string;
  public updatedDate?: Date;
  public RemoveFromAc?: string;
  public Remark?: string;
  public IsRejected?: boolean;
  public RejectedAircraftId?: number;
  public RejectedRefNo?: string;
  public PnDifferenceReasonRemark?: string;
  public Batch?: number;
  public RemovalTransactionType?: number;
  public EngineSerialNumber?: string;
}
